module.exports = __webpack_public_path__ + "img/logo.e04546c0.svg";